import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/HomePage'
import EWaybillReconcile from '@/components/EWaybillReconcile'
import Login from '@/components/Login'
import Logout from '@/components/Logout'
import AdminPage from '@/components/AdminPage'
import ReportPage from '@/components/ReportPage'
import GeneratePage from '@/components/GeneratePage'
import ExtendPage from '@/components/ExtendPage'
import PODManage from '@/components/PODManage'
import ContactDisplayPage from '@/components/ContactDisplayPage'
import CredentialPage from '@/components/admin/CredentialPage'
import UserPage from '@/components/admin/UserPage'
import TransporterPage from '@/components/admin/TransporterPage'
import VendorPage from '@/components/admin/VendorPage'
import ConsigneePage from '@/components/admin/ConsigneePage'
import LocationsPage from '@/components/admin/LocationsPage'
import ConfigPage from '@/components/admin/ConfigPage'
import EwbConfigPage from '../components/admin/EwbConfigPage'
import ValidatePage from '../components/ValidatePage'
import ContactPage from '../components/admin/ContactPage'
import Debug from '../components/admin/Debug'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/generate',
      name: 'generate',
      component: GeneratePage
    },
    {
      path: '/extend',
      name: 'extend',
      component: ExtendPage
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: ContactDisplayPage
    },
    {
      path: '/reports',
      name: 'reports',
      component: ReportPage
    },
    {
      path: '/reconciliation',
      name: 'reconciliation',
      component: EWaybillReconcile
    },
    {
      path: '/validate',
      name: 'validate',
      component: ValidatePage
    },
    {
      path: '/manage-pod',
      name: 'manage-pod',
      component: PODManage
    },
    {
      path: '/manage-pod/:from/:to/:loc/:tr/:what',
      name: 'dashboard-pod-link',
      component: PODManage
    },
    {
      path: '/manage-pod/:from/:to/:loc/:tr/:what/:group/:division',
      name: 'dashboard-pod-link-2',
      component: PODManage
    },
    {
      path: '/manage-pod/:from/:to/:loc/:tr/:what/:group/:division/:saletypes',
      name: 'dashboard-pod-link-2',
      component: PODManage
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/users',
      name: 'users',
      component: UserPage
    },
    {
      path: '/admin',
      name: 'admin',
      component: AdminPage,
      children: [
        {
          path: 'credentials',
          component: CredentialPage
        },
        {
          path: 'ewb-config',
          component: EwbConfigPage
        },
        {
          path: 'users',
          component: UserPage
        },
        {
          path: 'contact',
          component: ContactPage
        },
        {
          path: 'transporters',
          component: TransporterPage
        },
        {
          path: 'locations',
          component: LocationsPage
        },
        {
          path: 'customers',
          component: ConsigneePage
        },
        {
          path: 'vendors',
          component: VendorPage
        },
        {
          path: 'config',
          component: ConfigPage
        },
        {
          path: 'debug',
          component: Debug
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js